<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增个人消息"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="消息内容" prop="message_content">
                <el-input type="textarea" rows="10" v-model="ruleForm.message_content" placeholder="请输入消息内容"
                          autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="接收人" v-if="isAllShow == 1">
                <el-select v-model="ruleForm.obj" placeholder="请选择接收人"
                           style="width: 100%;">
                    <el-option
                            v-for="item in allRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">发送</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";

    export default {
        created() {
            this.type = this.$route.params.type;
            if (this.$route.params.user_id) {
                this.user_id = this.$route.params.user_id;
                this.isAllShow = 0;
            }
        },
        mounted() {
            localStorage.setItem('prev_page', 'system_message_add')
        },
        data() {
            return {
                isAllShow: 1,
                type: '',
                user_id: '',
                allRole: [
                    {
                        id: 6,
                        name: '全部'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    },
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    //{
                    //    id: 5,
                    //    name: '健康管理助理'
                    //},
                ],
                ruleForm: {
                    message_content: "",
                    obj: "",
                },
                rules: {
                    message_content: [
                        {required: true, message: "请输入职称全称", trigger: "blur"},
                    ],
                }
            };
        },
        methods: {

            // 返回上一页
            goBack() {
                window.history.go(-1);
            },

            // 提交表单
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.type == 1) {
                            var obj = this.user_id;
                        }  else {
                            var obj = this.ruleForm.obj == 6 ? 'all' : this.ruleForm.obj;
                        }
                        let params = {
                            'servername': 'Ruyi_ContentServices',
                            'method': 'sendMessage',
                            'params': {
                                type: this.type,
                                message_content: this.ruleForm.message_content,
                                obj: obj,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '发送成功',
                                duration: 1500,
                                onClose: function () {
                                    window.history.go(-1);
                                }
                            });
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        return false;
                    }
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
